module.exports = __webpack_public_path__ + "img/0-26.f297580c.jpg";